const o = {
  "@ado/base-application": {
    footer: {
      "terms-of-use": (e) => {
        const { normalize: n } = e;
        return n(["AGB"]);
      },
      disclaimer: (e) => {
        const { normalize: n } = e;
        return n(["Haftungsausschluss"]);
      },
      "about-us": (e) => {
        const { normalize: n } = e;
        return n(["\xDCber uns"]);
      },
      "cookie-policy": (e) => {
        const { normalize: n } = e;
        return n(["Cookie-Richtlinie"]);
      },
      "privacy-policy": (e) => {
        const { normalize: n } = e;
        return n(["Datenschutz"]);
      },
      "google-privacy-policy": (e) => {
        const { normalize: n } = e;
        return n(["Datenschutz"]);
      },
      "editorial-policy": (e) => {
        const { normalize: n } = e;
        return n(["Redaktionalle Leitlinien"]);
      },
      "terms-of-service": (e) => {
        const { normalize: n } = e;
        return n(["Nutzungsbedingungen die"]);
      },
      "use-of-site": (e) => {
        const { normalize: n, interpolate: r, named: t } = e;
        return n(["Ihr Besuch auf unserer Website unterliegt unseren ", r(t("tos")), ", ", r(t("disclaimer")), ", ", r(t("cookiePolicy")), " ", r(t("privacyPolicy")), " und ", r(t("editorialPolicy")), "."]);
      },
      "recaptcha-google": (e) => {
        const { normalize: n, interpolate: r, named: t } = e;
        return n(["Diese Website ist durch reCAPTCHA gesch\xFCtzt ", r(t("googlePrivacyPolicy")), " und ", r(t("googleTos")), " anwenden."]);
      },
      consent: (e) => {
        const { normalize: n, interpolate: r, named: t } = e;
        return n([r(t("siteBrand")), " ist keine Rechtsanwaltskanzlei und bietet keine Rechtsberatung. Wir stellen allgemeine Informationen und Software zur Verf\xFCgung, w\xE4hrend Sie f\xFCr deren richtige Verwendung verantwortlich sind. ", r(t("copyRight"))]);
      },
      "all-rights-reserved": (e) => {
        const { normalize: n } = e;
        return n(["Alle Rechte vorbehalten"]);
      },
      "terms-of-use-title": (e) => {
        const { normalize: n } = e;
        return n(["AGB"]);
      },
      "disclaimer-title": (e) => {
        const { normalize: n } = e;
        return n(["Haftungsausschluss"]);
      },
      "privacy-policy-title": (e) => {
        const { normalize: n } = e;
        return n(["Datenschutz"]);
      },
      "editorial-policy-title": (e) => {
        const { normalize: n } = e;
        return n(["Redaktionalle Leitlinien"]);
      }
    },
    "footer-links": {
      about: (e) => {
        const { normalize: n } = e;
        return n(["\xDCber uns"]);
      },
      "affilicate-program": (e) => {
        const { normalize: n } = e;
        return n(["Partnerprogramm"]);
      },
      blog: (e) => {
        const { normalize: n } = e;
        return n(["Blog"]);
      },
      "business-solutions": (e) => {
        const { normalize: n } = e;
        return n([]);
      },
      "cancel-page": (e) => {
        const { normalize: n } = e;
        return n(["Vertr\xE4ge hier k\xFCndigen"]);
      },
      careers: (e) => {
        const { normalize: n } = e;
        return n(["Karriere"]);
      },
      contact: (e) => {
        const { normalize: n } = e;
        return n(["Kontakt"]);
      },
      home: (e) => {
        const { normalize: n } = e;
        return n(["Startseite"]);
      },
      "law-library": (e) => {
        const { normalize: n } = e;
        return n(["Rechtsbibliothek"]);
      },
      "legal-documents": (e) => {
        const { normalize: n } = e;
        return n(["Unsere Dokumente"]);
      },
      "legal-notice": (e) => {
        const { normalize: n } = e;
        return n(["Impressum"]);
      },
      resources: (e) => {
        const { normalize: n } = e;
        return n(["Quellen"]);
      },
      "white-label-program": (e) => {
        const { normalize: n } = e;
        return n(["White-Label-Programm"]);
      }
    },
    "footer-policy-dialog": {
      "print-document": (e) => {
        const { normalize: n } = e;
        return n(["Dokument drucken"]);
      },
      "save-document": (e) => {
        const { normalize: n } = e;
        return n(["Dokument speichern"]);
      }
    },
    help: (e) => {
      const { normalize: n } = e;
      return n(["Hilfe"]);
    },
    more: (e) => {
      const { normalize: n } = e;
      return n(["Weitere L\xE4nder"]);
    },
    "help-center": (e) => {
      const { normalize: n } = e;
      return n(["Kundencenter"]);
    },
    countries: {
      "United States": (e) => {
        const { normalize: n } = e;
        return n(["Die USA"]);
      },
      Australia: (e) => {
        const { normalize: n } = e;
        return n(["Australien"]);
      },
      Austria: (e) => {
        const { normalize: n } = e;
        return n(["\xD6sterreich"]);
      },
      Canada: (e) => {
        const { normalize: n } = e;
        return n(["Kanada"]);
      },
      "United Kingdom": (e) => {
        const { normalize: n } = e;
        return n(["Gro\xDFbritannien"]);
      },
      Deutschland: (e) => {
        const { normalize: n } = e;
        return n(["Deutschland"]);
      },
      France: (e) => {
        const { normalize: n } = e;
        return n(["Frankreich"]);
      },
      India: (e) => {
        const { normalize: n } = e;
        return n(["Indien"]);
      },
      Ireland: (e) => {
        const { normalize: n } = e;
        return n(["Irland"]);
      },
      Mexico: (e) => {
        const { normalize: n } = e;
        return n(["Mexico"]);
      },
      "New Zealand": (e) => {
        const { normalize: n } = e;
        return n(["Neuseeland"]);
      },
      Nigeria: (e) => {
        const { normalize: n } = e;
        return n(["Nigeria"]);
      },
      Singapore: (e) => {
        const { normalize: n } = e;
        return n(["Singapur"]);
      },
      Spain: (e) => {
        const { normalize: n } = e;
        return n(["Spain"]);
      }
    },
    header: {
      "chat-online": (e) => {
        const { normalize: n } = e;
        return n(["Online-Gespr\xE4ch"]);
      },
      "email-us": (e) => {
        const { normalize: n } = e;
        return n(["Schreiben Sie uns eine E-Mail"]);
      },
      "create-free-account": (e) => {
        const { normalize: n } = e;
        return n(["Kostenlos registrieren"]);
      },
      "sign-in": (e) => {
        const { normalize: n } = e;
        return n(["Anmelden"]);
      },
      "search-this-site": (e) => {
        const { normalize: n } = e;
        return n(["Diese Seite durchsuchen..."]);
      },
      go: (e) => {
        const { normalize: n } = e;
        return n(["Los!"]);
      },
      "my-documents": (e) => {
        const { normalize: n } = e;
        return n(["Meine Dokumente"]);
      },
      "my-account": (e) => {
        const { normalize: n } = e;
        return n(["Mein Kundenkonto"]);
      },
      "sign-out": (e) => {
        const { normalize: n } = e;
        return n(["Abmelden"]);
      },
      "upgrade-account": (e) => {
        const { normalize: n } = e;
        return n(["Kundenkonto Erweitern"]);
      },
      All: (e) => {
        const { normalize: n } = e;
        return n(["Alle"]);
      },
      "all-documents": (e) => {
        const { normalize: n } = e;
        return n(["Alle Dokumente"]);
      }
    },
    "sign-in": {
      "already-have-account": (e) => {
        const { normalize: n } = e;
        return n(["Sie haben bereits ein Kundenkonto?"]);
      },
      "create-account-disclaimer": (e) => {
        const { normalize: n, interpolate: r, named: t } = e;
        return n(["Alle von Ihnen mitgeteilten Informationen bleiben absolut sicher und werden nicht an Dritte weitergegeben. Bitte lesen Sie unsere ", r(t("privacyPolicy")), ", ", r(t("tos")), ", und ", r(t("emailPolicy")), " f\xFCr weitere Informationen."]);
      },
      "create-an-account": (e) => {
        const { normalize: n } = e;
        return n(["Kostenloses Kundenkonto er\xF6ffnen"]);
      },
      "create-new-account": (e) => {
        const { normalize: n } = e;
        return n(["Ein neues Kundenkonto er\xF6ffnen"]);
      },
      "create-password": (e) => {
        const { normalize: n } = e;
        return n(["Passwort"]);
      },
      "check-email": (e) => {
        const { normalize: n } = e;
        return n(["\xDCberpr\xFCfen Sie jetzt Ihre E-Mails"]);
      },
      "common-error-message": (e) => {
        const { normalize: n } = e;
        return n(["Ein Fehler ist aufgetreten. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut."]);
      },
      "invalid-password-message": (e) => {
        const { normalize: n } = e;
        return n(["Bitte geben Sie eine g\xFCltige Passwort ein."]);
      },
      "invalid-email-message": (e) => {
        const { normalize: n } = e;
        return n(["Bitte geben Sie eine g\xFCltige E-Mail-Adresse ein."]);
      },
      "reset-password-success-first-message": (e) => {
        const { normalize: n, interpolate: r, named: t } = e;
        return n(["Wir haben an ", r(t("email")), " eine E-Mail mit Anweisungen zum Erstellen eines neuen Passwortes gesendet."]);
      },
      "reset-password-success-second-message": (e) => {
        const { normalize: n } = e;
        return n(["\xD6ffnen Sie die E-Mail und folgen Sie den Anweisungen, um fortzufahren."]);
      },
      "error-alert-title": (e) => {
        const { normalize: n } = e;
        return n(["Fehlermeldung"]);
      },
      "success-alert-title": (e) => {
        const { normalize: n } = e;
        return n(["Geschafft!"]);
      },
      dialog: {
        "creating-account": (e) => {
          const { normalize: n } = e;
          return n(["Kundenkonto wird er\xF6ffnet"]);
        },
        "signing-in": (e) => {
          const { normalize: n } = e;
          return n(["Anmeldung l\xE4uft"]);
        },
        "recovery-email": (e) => {
          const { normalize: n } = e;
          return n(["Wiederherstellungsemail wird versandt"]);
        },
        "answer-saved-header_male": (e) => {
          const { normalize: n, interpolate: r, named: t } = e;
          return n(["Ihr ", r(t("productName")), " wurde gespeichert"]);
        },
        "answer-saved-header_female": (e) => {
          const { normalize: n, interpolate: r, named: t } = e;
          return n(["Ihre ", r(t("productName")), " wurde gespeichert"]);
        },
        "answer-saved-header_neutral": (e) => {
          const { normalize: n, interpolate: r, named: t } = e;
          return n(["Ihr ", r(t("productName")), " wurde gespeichert"]);
        },
        "signed-in": {
          "answer-saved-message_male": (e) => {
            const { normalize: n, interpolate: r, named: t } = e;
            return n(["Ihr ", r(t("productName")), " wurde in Ihrem ", r(t("siteBrand")), "-Kundenkonto gespeichert."]);
          },
          "answer-saved-message_female": (e) => {
            const { normalize: n, interpolate: r, named: t } = e;
            return n(["Ihre ", r(t("productName")), " wurde in Ihrem ", r(t("siteBrand")), "-Kundenkonto gespeichert."]);
          },
          "answer-saved-message_neutral": (e) => {
            const { normalize: n, interpolate: r, named: t } = e;
            return n(["Ihr ", r(t("productName")), " wurde in Ihrem ", r(t("siteBrand")), "-Kundenkonto gespeichert."]);
          }
        },
        "create-account": {
          "answer-saved-message": (e) => {
            const { normalize: n, interpolate: r, named: t } = e;
            return n(["Sie haben ein Kundenkonto auf ", r(t("siteBrand")), " er\xF6ffnet. Wir werden Ihnen in K\xFCrze eine Best\xE4tigungsmail senden."]);
          }
        },
        "answer-saved-message1_male": (e) => {
          const { normalize: n, interpolate: r, named: t } = e;
          return n(["Sie k\xF6nnen jederzeit zur\xFCckkehren und Ihren ", r(t("productName")), " fertigstellen."]);
        },
        "answer-saved-message1_female": (e) => {
          const { normalize: n, interpolate: r, named: t } = e;
          return n(["Sie k\xF6nnen jederzeit zu ihrer ", r(t("productName")), " zur\xFCckkehren und sie fertigstellen."]);
        },
        "answer-saved-message1_neutral": (e) => {
          const { normalize: n, interpolate: r, named: t } = e;
          return n(["Sie k\xF6nnen jederzeit zu ihrem ", r(t("productName")), " zur\xFCckkehren und es fertigstellen."]);
        }
      },
      email: (e) => {
        const { normalize: n } = e;
        return n(["E-Mail-Adresse"]);
      },
      "email-policy": (e) => {
        const { normalize: n } = e;
        return n(["E-Mail-Richtlinie"]);
      },
      "forgot-password": (e) => {
        const { normalize: n } = e;
        return n(["Ich habe mein Passwort vergessen"]);
      },
      "if-you-prefer": (e) => {
        const { normalize: n, interpolate: r, named: t } = e;
        return n(["Sie k\xF6nnen entweder ", r(t("create")), " oder ", r(t("return")), "."]);
      },
      "no-account-text": (e) => {
        const { normalize: n } = e;
        return n(["Sie haben noch kein Kundenkonto?"]);
      },
      "no-thanks": (e) => {
        const { normalize: n } = e;
        return n(["Nein, danke"]);
      },
      password: (e) => {
        const { normalize: n } = e;
        return n(["Passwort"]);
      },
      "password-email-sent": (e) => {
        const { normalize: n } = e;
        return n(["Eine E-Mail mit Passwort wurde gesendet"]);
      },
      "password-reset": (e) => {
        const { normalize: n } = e;
        return n(["Passwort zur\xFCcksetzen"]);
      },
      "password-reset-instructions": (e) => {
        const { normalize: n } = e;
        return n(["Wir senden Ihnen per E-Mail Anweisungen, wie Ihr Passwort zur\xFCckgesetzt werden kann."]);
      },
      "return-sign-in": (e) => {
        const { normalize: n } = e;
        return n(["Auf die Anmeldeseite zur\xFCckkehren"]);
      },
      "sign-in": (e) => {
        const { normalize: n } = e;
        return n(["Anmelden"]);
      },
      "sign-in-text": (e) => {
        const { normalize: n, interpolate: r, named: t } = e;
        return n(["Melden Sie sich mit Ihrem ", r(t("SiteBrand")), "-Kundenkonto an"]);
      },
      "save-document": (e) => {
        const { normalize: n } = e;
        return n(["Mein Dokument speichern"]);
      },
      "save-product-create-text": (e) => {
        const { normalize: n, interpolate: r, named: t } = e;
        return n(["Speichern Sie Ihr ", r(t("productName")), " mit dem kostenlosen Kundenkonto"]);
      },
      "save-product-login-text": (e) => {
        const { normalize: n, interpolate: r, named: t } = e;
        return n(["Melden Sie sich an, um Ihr ", r(t("productName")), " zu speichern"]);
      }
    },
    "redirect-prompt": {
      "your-country-is-set-to": (e) => {
        const { normalize: n, interpolate: r, named: t } = e;
        return n(["Ihre L\xE4ndereinstellung ist ", r(t("countryName"))]);
      },
      "change-to": (e) => {
        const { normalize: n, interpolate: r, named: t } = e;
        return n(["\xC4ndern zu ", r(t("countryName"))]);
      },
      "dont-change": (e) => {
        const { normalize: n } = e;
        return n(["Nicht \xE4ndern"]);
      }
    }
  }
};
export {
  o as default
};
//# sourceMappingURL=index.js.map
